import { createRoot } from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import { ErrorBoundary } from 'react-error-boundary';

import { getClient } from './utils/apollo-client';
import profile, { ProfileProvider } from './profile';
import TopBannerContainer from './components/topBanner/TopBannerContainer';

function topBannerModule(): void {
    const container = document.getElementById('top-banner');
    if (!container) {
        return;
    }

    createRoot(container).render(
        <ApolloProvider client={getClient()}>
            <ProfileProvider profile={profile}>
                <ErrorBoundary fallback={null}>
                    <TopBannerContainer />
                </ErrorBoundary>
            </ProfileProvider>
        </ApolloProvider>
    );
}

export default topBannerModule;
